import React from "react";

const ShipmentSummaryComponentLoadable = React.lazy(() =>
  import("./ShipmentSummaryComponent")
);

export { ShipmentSummaryComponentLoadable };